export default "__VITE_ASSET__CD7nA0bh__"